import React, { useState } from "react";
import { Table, Checkbox } from "antd";
import edit from "../../assest/Button.png";
import deleteimg from "../../assest/newButton.png";
import DeleteModal from "../Modal/Deletemodal";
import { useLocation, useNavigate } from "react-router-dom";
import DeleteNotification from "../Notification/DeleteNotification";
import check from "../../assest/check.png";
import UpdateNotification from "../Notification/UpdateNotification";
import EditCampaign from "../Modal/EditCampaign";
import moment from "moment";

const CampaignsTable = ({
  campaigns,
  selectedCheckboxes,
  onCheckboxChange,
  oncheckallboxchange,
}) => {
  const location = useLocation();
  const currentRoute = location.pathname;
  const navigate = useNavigate();

  const [modalVisible, setModalVisible] = useState(false);
  const [notificationmodal, setNotificationmodal] = useState(false);
  const [editmodalVisible, setEditModalVisible] = useState(false);
  const [editnotificationmodal, setEditNotificationmodal] = useState(false);
  const [selectedCampaignId, setSelectedCampaignId] = useState([]);
  const [editCampagin, SeteditCampagin] = useState(null);

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });

  const deletebtn = (id) => {
    setSelectedCampaignId((prevState) => {
      // Add id to the selected campaign IDs, if not already present
      if (!prevState.includes(id)) {
        return [...prevState, id];
      }
      return prevState;
    });

    setModalVisible(true);
  };

  const editmodal = (record) => {
    SeteditCampagin(null);
    navigate("/campaignflow", {
      state: { campaign: record },
    });
    setEditModalVisible(true);
  };
  const columns = [
    {
      title: <Checkbox onChange={(e) => oncheckallboxchange(e)} />,
      dataIndex: "checkbox",
      // width:'30px',
      width: 10,
      key: "checkbox",
      onCell: () => ({ onClick: (e) => e.stopPropagation() }),
      render: (_, record) => (
        <Checkbox
          onChange={(e) => onCheckboxChange(e, record)}
          checked={selectedCheckboxes.includes(record._id)}
        />
      ),
    },
    {
      title: "Campaign ID",
      dataIndex: "_id",
      key: "_id",
      width: 120,
      render: (_id) => {
        if (!_id) return "-";
        return `${_id.slice(-6)}`;
      },
    },
    {
      title: "Campaign Name",
      dataIndex: "name",
      key: "name",
      width: "40%",
    },
    {
      title: "Date & Time",
      dataIndex: "createdDate",
      key: "createdDate",
      width: "20%",
      render: (createdDate) => {
        return moment(createdDate).local().format("MMM D, YYYY hh:mm A z"); // Formats date
      },
      // width: 50,
    },
    {
      title: "Users",
      dataIndex: "userCount",
      key: "userCount",
      // width: '18%',
      width: "9%",
      render: (text) =>
        campaigns?.usercampaign?.[0]?.targetGroup?.length > 0
          ? `${text} Users`
          : `1 Users`,
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      //  width: 10,
      onCell: () => ({ onClick: (e) => e.stopPropagation() }),
      render: (_, record) => (
        <div className="actions">
          {/* <img style={{ cursor: 'pointer' }} onClick={() => editmodal(record)}  src={edit} alt="Edit" /> */}

          {record?.campaignStatus === "sent" ? (
            <img src={check} alt="check" />
          ) : (
            <>
              <img
                onClick={() => {
                  const currentDate = new Date();
                  const campaignDate = new Date(record.createdDate);

                  if (campaignDate < currentDate) {
                    return;
                  }

                  editmodal(record);
                }}
                src={edit}
                alt="Edit"
                style={{
                  cursor:
                    new Date(record.createdDate) < new Date()
                      ? "not-allowed"
                      : "pointer",
                  opacity: new Date(record.createdDate) < new Date() ? 0.5 : 1,
                }}
              />
              <img
                style={{ cursor: "pointer" }}
                onClick={() => deletebtn(record._id)}
                src={deleteimg}
                alt="Delete"
              />
            </>
          )}
        </div>
      ),
    },
  ];

  const dataSource = campaigns?.usercampaign
    ?.slice() // Create a copy to avoid mutating the original array
    .sort((a, b) => {
      const dateA = new Date(a.createdDate || 0);
      const dateB = new Date(b.createdDate || 0);
      return dateB - dateA; // Descending order (newest first)
    })
    .map((campaign, index) => ({
      key: index,
      user: 2,
      ...campaign,
    }));

  // {`ST000${index + 1}`}
  // </div>
  // <div>
  //     {campaign.name}
  // </div>
  // <div>
  // {moment(campaign.startDate).local().format('MMM D, YYYY hh:mm A z')}

  return (
    <>
      <Table
        className="table"
        dataSource={dataSource}
        columns={columns}
        onRow={(record) => ({
          onClick: () =>
            navigate(`/dashboard/my-campaigns/${record._id}`, {
              state: { campaign: record },
            }),
        })}
        rowClassName="cursor-pointer hover:bg-gray-100 transition"
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: dataSource,
          onChange: (page, pageSize) => {
            setPagination({
              current: page,
              pageSize: pageSize,
            });
          },
        }}

        // pagination={true}
      />

      <DeleteModal
        visible={modalVisible}
        onClose={() => setModalVisible(false)}
        currentRoute={currentRoute}
        setNotificationmodal={setNotificationmodal}
        selectedCampaignId={selectedCampaignId}
      />

      <DeleteNotification
        visible={notificationmodal}
        onClose={() => setNotificationmodal(false)}
        currentRoute={currentRoute}
      />

      <EditCampaign
        visible={editmodalVisible}
        onClose={() => setEditModalVisible(false)}
        //    currentRoute={}
        setEditNotificationmodal={setEditNotificationmodal}
        editCampagin={editCampagin}
      />

      <UpdateNotification
        visible={editnotificationmodal}
        onClose={() => setEditNotificationmodal(false)}
      />
    </>
  );
};

export default CampaignsTable;
